import Button from "components/Button/Button";
import { getTimeRemaining } from "helpers/utils";
import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import GovernanceStore from "stores/GovernanceStore";
import { TimerData } from "types";

function RegeneratorActions() {
  const { regeneratorState, nextRamRouterUpdateTime, stagingReadyDate } = GovernanceStore;
  const [timeLeft, setTimeLeft] = useState<TimerData | null>(null);
  const [timeLeftForNextUpdate, setTimeLeftForNextUpdate] = useState<TimerData | null>(null);
  const { weightedNumber } = GovernanceStore;

  useEffect(() => {
    let interval;
    if (regeneratorState === "staging-waiting") {
      interval = setInterval(() => {
        const timeRemaining = getTimeRemaining(stagingReadyDate);
        setTimeLeft(timeRemaining);
      }, 1000);
    }
    if (stagingReadyDate <= new Date()) {
      GovernanceStore.getUpdateStagingReadyTime();
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [stagingReadyDate, regeneratorState]);

  useEffect(() => {
    let interval;
    if (nextRamRouterUpdateTime && regeneratorState === "waiting-next") {
      interval = setInterval(() => {
        const timeRemaining = getTimeRemaining(nextRamRouterUpdateTime);
        setTimeLeftForNextUpdate(timeRemaining);
      }, 1000);
    }
    if (nextRamRouterUpdateTime <= new Date()) {
      GovernanceStore.getLastRAMRouterUpdateTime();
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [regeneratorState, nextRamRouterUpdateTime]);

  return (
    <>
      <div className="section-title section-title-global-actions">Regenerator actions</div>
      {regeneratorState === "default" && (
        <Button type="positive" onClick={() => GovernanceStore.enterRegeneratorUpdateStagingMode()}>
          Enter staging mode
        </Button>
      )}
      {regeneratorState === "staging-waiting" && timeLeft && timeLeft.seconds >= 0 && (
        <Button type="neutral" className="global-button disabled" style={{ color: "black" }}>
          In staging mode ({timeLeft.minutes}m {timeLeft.seconds}s){" "}
        </Button>
      )}
      {regeneratorState === "ready" && (
        <Button type="positive" onClick={() => GovernanceStore.updateRAMRouterRegeneratorTax()}>
          Change funding rate to proposed {weightedNumber}%
        </Button>
      )}
      {regeneratorState === "waiting-next" && timeLeftForNextUpdate && (
        <Button type="neutral" className="global-button disabled" style={{ color: "black" }}>
          Next proposal in {timeLeftForNextUpdate.hours}h {timeLeftForNextUpdate.minutes}m
        </Button>
      )}
    </>
  );
}

export default observer(RegeneratorActions);
